import { css, type Theme } from "@emotion/react";

export const FeaturedBrandBox = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  max-width: 26rem;
  padding: 1.5rem 1rem 1rem 1rem;
  border: 1px solid ${theme.system.borderBase};
  border-radius: 0.5rem;
  gap: 1rem;
`;

export const FeaturedBrandLogo = css`
  display: flex;
  height: 5.625rem;
  margin: 0 auto;
  padding: 1rem;
  border: 1rem;
  align-items: center;
  justify-content: center;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const FeaturedBrandBottomBox = css`
  display: flex;
  gap: 0.5rem;
`;

export const FeaturedBrandImage = css`
  display: flex;
  width: 9.125rem;
  height: 9.125rem;
  margin: 0 auto;
  padding: 0.5rem;
  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const FeaturedBrandContent = css`
  display: flex;
  padding: 0.5rem 0;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;
